import { onMounted, onUnmounted } from 'vue';

export function useFlowKeyboard({ onDelete, onUndo, onEscape }) {
  const handleKeydown = (event) => {
    const activeElement = document.activeElement;
    const isTyping = activeElement && (
      activeElement.tagName === 'INPUT' ||
      activeElement.tagName === 'TEXTAREA' ||
      activeElement.isContentEditable
    );

    if (event.key === 'Delete' || event.key === 'Backspace') {
      if (!isTyping) {
        event.preventDefault();
        onDelete?.();
      }
    } else if (event.key === 'Escape') {
      onEscape?.();
    } else if ((event.ctrlKey || event.metaKey) && event.key === 'z') {
      if (!isTyping) {
        event.preventDefault();
        onUndo?.();
      }
    }
  };

  onMounted(() => document.addEventListener('keydown', handleKeydown));
  onUnmounted(() => document.removeEventListener('keydown', handleKeydown));
}
